import { render, staticRenderFns } from "./ColorProperties.vue?vue&type=template&id=717daa2b&scoped=true"
import script from "./ColorProperties.vue?vue&type=script&setup=true&lang=ts"
export * from "./ColorProperties.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./ColorProperties.vue?vue&type=style&index=0&id=717daa2b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "717daa2b",
  null
  
)

export default component.exports